// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.row .row-banner {
  margin-top: 30px;
  margin-bottom: 10px;
}

.margin-20-10 {
  margin-top: 20px;
  margin-bottom: 10px;
}

.margin-10-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.column {
  display: flex;
  flex-direction: column;
  flex: 1 100%;
  margin-right: 20px;
  margin-top: 8px;
}

.column-display-block {
  display: block;
}

.banner {
  background-color: #efefef;
  padding-top: 10px;
  height: 41px;
  width: 100%;
}
.banner .banner-text {
  font-size: 1.3rem;
  font-weight: bold;
  color: #324758;
  text-transform: uppercase;
  font-family: serif;
}

.location {
  margin-top: 10px;
  margin-bottom: 10px;
}
.location .location-district .location-campus {
  display: block;
  padding-top: 10px;
  padding-left: 10px;
}

.discussion {
  margin-top: 10px;
}
.discussion .discussion-textbox {
  min-height: 100px;
}

.fs-name {
  float: left;
  padding-top: 10px;
  padding-right: 10px;
}

.fs-signature {
  padding-right: 15px;
  float: left;
  width: 57%;
  padding-top: 10px;
}

mat-form-field {
  width: 100%;
}

.mat-mdc-input-element::-webkit-calendar-picker-indicator {
  display: block;
}

.validation-error {
  border: 1px solid #f00 !important;
}

.validation-error-text {
  color: #f00 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/intern/observation/informal-observation/informal-observation.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;AACI;EACI,gBAAA;EACA,mBAAA;AACR;;AAGA;EACI,gBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AAAJ;AAEI;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAAR;;AAIA;EACI,gBAAA;EACA,mBAAA;AADJ;AAGI;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;AADR;;AAKA;EACI,gBAAA;AAFJ;AAII;EACI,iBAAA;AAFR;;AAMA;EACI,WAAA;EACA,iBAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,mBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,WAAA;AAHJ;;AAMA;EACI,cAAA;AAHJ;;AAMA;EACI,iCAAA;AAHJ;;AAME;EACE,sBAAA;AAHJ","sourcesContent":[".row {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n\n    .row-banner {\n        margin-top: 30px;\n        margin-bottom: 10px;\n    }\n}\n\n.margin-20-10 {\n    margin-top: 20px;\n    margin-bottom: 10px;\n}\n\n.margin-10-10 {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.column {\n    display: flex;\n    flex-direction: column;\n    flex: 1 100%;\n    margin-right: 20px;\n    margin-top: 8px;\n}\n\n.column-display-block {\n    display: block;\n}\n\n.banner {\n    background-color: #efefef;\n    padding-top:10px;\n    height: 41px;\n    width: 100%;\n\n    .banner-text {\n        font-size: 1.3rem; \n        font-weight: bold;\n        color: #324758;\n        text-transform: uppercase;\n        font-family:serif;\n    }\n}\n\n.location {\n    margin-top: 10px;\n    margin-bottom: 10px;\n\n    .location-district .location-campus {\n        display: block;\n        padding-top: 10px;\n        padding-left: 10px;\n    }\n}\n\n.discussion {\n    margin-top: 10px;\n\n    .discussion-textbox {\n        min-height: 100px;\n    }\n}\n\n.fs-name {\n    float: left;\n    padding-top: 10px;\n    padding-right: 10px;\n}\n\n.fs-signature {\n    padding-right: 15px;\n    float: left;\n    width: 57%;\n    padding-top: 10px;\n}\n\nmat-form-field {\n    width: calc(100%);\n}\n\n.mat-mdc-input-element::-webkit-calendar-picker-indicator {\n    display: block;\n}\n\n.validation-error {\n    border: 1px solid #f00 !important;\n  }\n  \n  .validation-error-text {\n    color: #f00 !important;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
